import React from 'react';
import '../styles/footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="footer__text">© 2023 Rafael Rivera</p>
    </footer>
  );
};

export default Footer;
